export const HERO_BREAKPOINT = 1200;
export const SUBSCRIPTION_TEXTBLOCK_BREAKPOINT = 1200;
export const MOBILE_BREAKPOINT = 430;
export const FILTER_BREAKPOINT = 1024; // BP for when to show filter modal vs filter menu
